import * as React from "react";

import { Box, Stack, Tabs, Tab, SxProps } from "@mui/material";

const a11yProps = (index: number) => ({
  id: `simple-tab-${index}`,
  "aria-controls": `simple-tabpanel-${index}`,
});

export interface WcTabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const WcTabPanel = (props: WcTabPanelProps & { sx?: SxProps }) => {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Stack sx={props.sx}>{children}</Stack>}
    </div>
  );
};

export interface WcTabProps {
  id: string;
  tabPanels: string[] | React.ReactNode[];
  children?: React.ReactNode;
  onValueChanged: (value: number) => void;
  externalValue?: number;
  fullHeightAndWidth?: boolean;

  tabSx?: SxProps;
  containerSx?: SxProps;
}

export const WcTab = ({
  id,
  tabPanels,
  children,
  onValueChanged,
  externalValue = 0,
  fullHeightAndWidth = true,
  tabSx,
  containerSx,
}: WcTabProps) => {
  const [value, setValue] = React.useState(0);

  React.useEffect(() => {
    if (externalValue !== undefined && externalValue !== value) setValue(externalValue);
  }, [externalValue, value]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    onValueChanged(newValue);
  };

  return (
    <Stack id={id} height={fullHeightAndWidth ? "100%" : "auto"} width={fullHeightAndWidth ? "100%" : "auto"} sx={containerSx}>
      <Box sx={{ borderBottom: 1, borderColor: "divider", ...tabSx }}>
        <Tabs value={value} onChange={handleChange}>
          {tabPanels &&
            tabPanels.map((tabPanel: string | React.ReactNode, index: number) => {
              if (tabPanel && tabPanel !== "") {
                return <Tab key={index} label={tabPanel} {...a11yProps(index)} />;
              } else {
                return undefined;
              }
            })}
        </Tabs>
      </Box>
      {children}
    </Stack>
  );
};

export default WcTab;
